import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { AlertTriangle } from 'lucide-react';

interface DeleteConfirmDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    personName: string;
    isLoading?: boolean;
}

export function DeleteConfirmDialog({
    isOpen,
    onClose,
    onConfirm,
    personName,
    isLoading,
}: DeleteConfirmDialogProps) {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 shadow-xl transition-all">
                                <div className="flex items-center gap-4 mb-4">
                                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                                        <AlertTriangle className="w-6 h-6 text-red-600" />
                                    </div>
                                    <div>
                                        <Dialog.Title className="text-lg font-bold text-gray-900">
                                            Xác nhận xóa
                                        </Dialog.Title>
                                        <p className="text-sm text-gray-500 mt-1">
                                            Hành động này không thể hoàn tác
                                        </p>
                                    </div>
                                </div>

                                <p className="text-gray-700 mb-6">
                                    Bạn có chắc chắn muốn xóa <strong>{personName}</strong> khỏi cây gia phả?
                                    Tất cả thông tin liên quan sẽ bị xóa vĩnh viễn.
                                </p>

                                <div className="flex gap-3">
                                    <button
                                        type="button"
                                        onClick={onClose}
                                        className="btn btn-secondary flex-1"
                                        disabled={isLoading}
                                    >
                                        Hủy
                                    </button>
                                    <button
                                        type="button"
                                        onClick={onConfirm}
                                        className="btn bg-red-600 text-white hover:bg-red-700 flex-1"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? 'Đang xóa...' : 'Xóa'}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}
